import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { 
  FLIGHT_PASSENGER_MAX, 
  PassengerArrangement, 
  PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

@Component({
  selector: 'app-search-bar-operator',
  templateUrl: './search-bar-operator.component.html',
  styleUrls: ['./search-bar-operator.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SearchBarOperatorComponent implements OnInit {

  public quantity: number = 0;

  @Input() type: string;
  @Input() selector: string;
  @Input() initialQuantity: number = 0;
  @Input() searchBy: string = SearchBy.FLIGHTS;
  @Input() totalPassengers: number = 0;
  @Input() allTotalPassengers: number = 0;
  @Input() maxPassengers: number;
  @Input() passengerArrangement: PassengerArrangement[];

  @Output() quantityEmmiter: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    this.quantity = this.initialQuantity;
    if (this.totalPassengers === 0) {
      this.totalPassengers = this.type === PassengerType.ADULTS 
        ? this.quantity
        : this.initialQuantity;
    }
  }

  get infantMaxValue(): number {
    const adults = this.passengerArrangement?.find((p) => p.id === PassengerType.ADULTS);
    return adults?.quantity ?? 1;
  }
  
  get adultMinValue(): number {
    const infants = this.passengerArrangement?.find((p) => p.id === PassengerType.INFANTS);
    return Math.max((infants?.quantity ?? 1), 1);
  }

  get minValue(): number {
    return this.type === PassengerType.ADULTS ? 
      this.searchBy === SearchBy.FLIGHTS ? 
        this.adultMinValue : 1 : 
      0;
  }

  public maxValue(): number {
    const remainingSpace = this.maxPassengers - this.totalPassengers + this.quantity;
    if (this.searchBy === SearchBy.FLIGHTS && this.type === PassengerType.INFANTS) {
      return Math.min(this.infantMaxValue, remainingSpace);
    } else if (this.searchBy === SearchBy.PACKAGES) {
      const remainingSpaceTotal = FLIGHT_PASSENGER_MAX - this.allTotalPassengers + this.quantity;
      return Math.min(remainingSpace, remainingSpaceTotal);
    } else {
      return Math.min(remainingSpace, this.maxPassengers);
    }
  }
}
